// Module
var code = "<span translate-once=\"lessons.stream.upload_unofficial_transcripts_modal.tooltip_message\" translate-compile></span>";
// Exports
export default code;